import Config from '../config';
import { AxiosInstance } from '../helpers/AxiosInstance';

const getAllApiAccess = () => {
    return AxiosInstance.get(`${Config.API_URL}/api/PublicApi`);
};

const createApiAccess = (data) => {
    return AxiosInstance.post(`${Config.API_URL}/api/PublicApi`, data);
};

const updateApiAccess = (data) => {
    return AxiosInstance.patch(`${Config.API_URL}/api/PublicApi/${data?.id}`, data);
};

const revokeApiAccess = (id: string) => {
    return AxiosInstance.post(`${Config.API_URL}/api/PublicApi/${id}/revoke`);
};

export const ApiAccessService = {
    getAllApiAccess,
    createApiAccess,
    updateApiAccess,
    revokeApiAccess,
}